var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"background-bg"},[_c('div',[_c('img',{staticClass:"loader-size",attrs:{"src":require("../../assets/gif/loader.gif"),"alt":"CanPayLoader"}})])])
}]

export { render, staticRenderFns }